import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../contexts/AuthContext';

export default function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', business_name: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState('');

  const [emailOtp, setEmailOtp] = useState('');
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailOtpLoading, setEmailOtpLoading] = useState(false);
  const [emailOtpError, setEmailOtpError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSendOtp = async () => {
    const cleanPhone = form.phone.replace(/[^0-9]/g, '');
    if (cleanPhone.length < 10) return setOtpError('Enter a valid WhatsApp number');
    setOtpLoading(true); setOtpError('');
    try {
      await api.post('/auth/send-registration-otp', { phone: cleanPhone });
      setOtpSent(true);
    } catch (e) {
      setOtpError(e.response?.data?.error || 'Failed to send OTP');
    }
    setOtpLoading(false);
  };

  const handleVerifyOtp = async () => {
    const cleanPhone = form.phone.replace(/[^0-9]/g, '');
    if (!otp) return setOtpError('Enter the OTP');
    setOtpLoading(true); setOtpError('');
    try {
      await api.post('/auth/verify-otp', { phone: cleanPhone, otp });
      setOtpVerified(true);
    } catch (e) {
      setOtpError(e.response?.data?.error || 'Invalid OTP');
    }
    setOtpLoading(false);
  };

  const handleSendEmailOtp = async () => {
    if (!form.email) return setEmailOtpError('Enter your email first');
    setEmailOtpLoading(true); setEmailOtpError('');
    try {
      await api.post('/auth/send-email-otp', { email: form.email });
      setEmailOtpSent(true);
    } catch (e) {
      setEmailOtpError(e.response?.data?.error || 'Failed to send email OTP');
    }
    setEmailOtpLoading(false);
  };

  const handleVerifyEmailOtp = async () => {
    if (!emailOtp) return setEmailOtpError('Enter the OTP');
    setEmailOtpLoading(true); setEmailOtpError('');
    try {
      await api.post('/auth/verify-email-otp', { email: form.email, otp: emailOtp });
      setEmailVerified(true);
    } catch (e) {
      setEmailOtpError(e.response?.data?.error || 'Invalid OTP');
    }
    setEmailOtpLoading(false);
  };

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.password || !form.business_name || !form.phone) {
      return setError('All fields required!');
    }
    if (!emailVerified) {
      return setError('Please verify your email first');
    }
    if (!otpVerified) {
      return setError('Please verify your WhatsApp number first');
    }
    setLoading(true); setError('');
    try {
      await api.post('/auth/register', { ...form, phone: form.phone.replace(/[^0-9]/g, '') });
      await login(form.email, form.password);
      navigate('/connect-shopify');
    } catch (e) {
      setError(e.response?.data?.error || 'Registration failed');
    }
    setLoading(false);
  };

  const inp = {
    width: '100%', padding: '12px 16px', borderRadius: 10,
    border: '1px solid #e5e7eb', fontSize: 14, outline: 'none',
    fontFamily: 'inherit', boxSizing: 'border-box'
  };

  const smallBtnStyle = {
    padding: '0 16px', borderRadius: 10, border: 'none',
    background: '#25D366', color: '#fff', fontWeight: 600, fontSize: 13,
    cursor: 'pointer', whiteSpace: 'nowrap'
  };

  const submitDisabled = loading || !otpVerified || !emailVerified;
  const submitLabel = loading
    ? '⏳ Creating account...'
    : !emailVerified
      ? 'Verify email first'
      : !otpVerified
        ? 'Verify WhatsApp number first'
        : '🚀 Create Account';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f4f6f9', fontFamily: 'DM Sans, sans-serif'
    }}>
      <div style={{
        background: '#fff', borderRadius: 20, padding: '48px 40px',
        width: '100%', maxWidth: 440, boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 32, fontWeight: 800, color: '#25D366', marginBottom: 8 }}>VBOT</div>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Create your account</div>
          <div style={{ fontSize: 13, color: '#6b7280' }}>Start your WhatsApp marketing journey</div>
        </div>

        {error && (
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca',
            borderRadius: 10, padding: '12px 16px', marginBottom: 20,
            color: '#dc2626', fontSize: 13
          }}>❌ {error}</div>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Your Name</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
              placeholder="John Doe" style={inp} />
          </div>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Business Name</label>
            <input value={form.business_name} onChange={e => setForm({...form, business_name: e.target.value})}
              placeholder="Fresh Mart" style={inp} />
          </div>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Email</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={form.email} onChange={e => { setForm({...form, email: e.target.value}); setEmailOtpSent(false); setEmailVerified(false); setEmailOtp(''); }}
                placeholder="you@example.com" type="email" disabled={emailVerified} style={{ ...inp, flex: 1 }} />
              <button type="button" onClick={handleSendEmailOtp} disabled={emailOtpLoading || emailVerified || !form.email} style={{
                ...smallBtnStyle,
                background: emailVerified ? '#d1fae5' : '#25D366',
                color: emailVerified ? '#059669' : '#fff',
                cursor: (emailOtpLoading || emailVerified || !form.email) ? 'not-allowed' : 'pointer',
                opacity: (emailOtpLoading || !form.email) && !emailVerified ? 0.6 : 1
              }}>
                {emailVerified ? '✓ Verified' : emailOtpLoading ? 'Sending...' : emailOtpSent ? 'Resend OTP' : 'Send OTP'}
              </button>
            </div>
            {emailOtpSent && !emailVerified && (
              <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                <input value={emailOtp} onChange={e => setEmailOtp(e.target.value)}
                  placeholder="Enter email OTP" style={{ ...inp, flex: 1 }} />
                <button type="button" onClick={handleVerifyEmailOtp} disabled={emailOtpLoading} style={{
                  padding: '0 16px', borderRadius: 10, border: '1px solid #25D366',
                  background: '#fff', color: '#25D366', fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap'
                }}>{emailOtpLoading ? 'Verifying...' : 'Verify'}</button>
              </div>
            )}
            {emailOtpError && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 6 }}>{emailOtpError}</div>}
          </div>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>WhatsApp Number</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})}
                placeholder="91XXXXXXXXXX" disabled={otpVerified} style={{ ...inp, flex: 1 }} />
              <button type="button" onClick={handleSendOtp} disabled={otpLoading || otpVerified} style={{
                padding: '0 16px', borderRadius: 10, border: 'none',
                background: otpVerified ? '#d1fae5' : '#25D366', color: otpVerified ? '#059669' : '#fff',
                fontWeight: 600, fontSize: 13, cursor: otpVerified ? 'default' : 'pointer', whiteSpace: 'nowrap'
              }}>
                {otpVerified ? '✓ Verified' : otpSent ? 'Resend OTP' : 'Send OTP'}
              </button>
            </div>
            {otpSent && !otpVerified && (
              <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                <input value={otp} onChange={e => setOtp(e.target.value)}
                  placeholder="Enter OTP" style={{ ...inp, flex: 1 }} />
                <button type="button" onClick={handleVerifyOtp} disabled={otpLoading} style={{
                  padding: '0 16px', borderRadius: 10, border: '1px solid #25D366',
                  background: '#fff', color: '#25D366', fontWeight: 600, fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap'
                }}>Verify</button>
              </div>
            )}
            {otpError && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 6 }}>{otpError}</div>}
          </div>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>Password</label>
            <input value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              placeholder="Min 6 characters" type="password" style={inp} />
          </div>

          <button onClick={handleSubmit} disabled={submitDisabled} style={{
            width: '100%', padding: '13px', borderRadius: 10, border: 'none',
            background: submitDisabled ? '#9ca3af' : '#25D366', color: '#fff',
            fontWeight: 700, fontSize: 15, cursor: submitDisabled ? 'not-allowed' : 'pointer', marginTop: 8
          }}>
            {submitLabel}
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#6b7280' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#25D366', fontWeight: 600, textDecoration: 'none' }}>
            Login
          </Link>
        </div>
      </div>
    </div>
  );
}
